import React from "react";
import { AppWrap, MotionWrap } from "../../wrapper";
import Contact from "./Contact";
import QuickLinks from "../Footer/QuickLinks";

const ContactPage = () => (
  <div>
    <Contact />
    <QuickLinks />
  </div>
);

export default AppWrap(
  MotionWrap(ContactPage, "app__contact"),
  "contactus",
  "app__whitebg"
);
